<section class="flex flex-column justify-content-between h-full overflow-auto" id="main-outer">
  <app-header></app-header>
  <div class="bg-primary h-full mid-section">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</section>